import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ErrorResponse } from '@core/error/error-response.model';

export type AbstractFormHandlers = {
    handlerSave?: <T>(body: T) => void;
    handlerCreate?: <T>(body: T) => void;
    handlerSubmit?: <T>(body: T) => void;
};

@Component({
    selector: 'app-abstract-form',
    standalone: true,
    imports: [],
    templateUrl: './abstract-form.component.html',
    styleUrl: './abstract-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AbstractFormComponent {
    /**
     * Read-only mode flag
     */
    @Input() public lyView: boolean;
    /**
     * Server pending flag
     */
    @Input() public error: ErrorResponse;
    /**
     * Form edit entity flag
     */
    @Input() public isEditMode: boolean;
    /**
     * Form handlers
     */
    @Input() public handlers: AbstractFormHandlers;

    /**
     * termModeValue
     */
    @Input() public set termCode(termCode: string) {
        if (this.form && termCode) {
            this.form.patchValue(
                {
                    termCode,
                },
                {
                    emitEvent: false,
                },
            );
        }
    }

    /**
     * Server pending flag
     */
    @Input() public set pending(pending: boolean) {
        if (this.form) {
            if (pending) {
                this.error = null;
                this.form.markAsPending();
            } else {
                this.form.updateValueAndValidity();
            }
        }
    }

    public readonly form: FormGroup;

    public handlerCreate: () => void = () => {};

    public handlerSave: () => void = () => {};

    public handlerSubmit: () => void = () => {};
}
